var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:({ backgroundColor: _vm.backgroundColor })},[_c('v-progress-circular',{staticClass:"loader-main",attrs:{"size":"120","color":"#FC7800","width":"5","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }